import FormSection from 'components/CreationForms/base/FormSection';
import CustomFields from 'components/CreationForms/fields/CustomFields';
import { ExternalProperty } from 'crono-fe-common/types/externalProperty';

interface TagsSectionProps {
  tags: ExternalProperty[];
  values: Record<number, string>;
  onTagClick: (option: string | null, tag: ExternalProperty) => void;
}

/** "Tags" block of the creation forms. Values are matched to tags by id. */
const TagsSection = ({ tags, values, onTagClick }: TagsSectionProps) => {
  if (tags.length === 0) return null;

  return (
    <FormSection title="Tags">
      <CustomFields tags={tags} values={values} onTagClick={onTagClick} />
    </FormSection>
  );
};

export default TagsSection;
